module.exports = __webpack_public_path__ + "media/time_revolution.5f271f22.mp4";